import { useMemo, useEffect } from 'react';

import { tableStore } from '../stores/table-store';
import { useProStudioCtxSelector } from '../xstate/app.xstate';
import { useCurrentRoute } from './use-current-route';
import { ProStudioPages } from './use-pro-studio-routes';

export const useTableStoreSync = () => {
  // console.log('=====================TableStore sync=====================');

  const isHomePage = useCurrentRoute().label === ProStudioPages.HOME;
  const isConfigurationsPage =
    useCurrentRoute().label === ProStudioPages.CONFIGURATIONS;
  const isWorkflowsPage = useCurrentRoute().label === ProStudioPages.WORKFLOWS;

  const isFirstLevelPage =
    isHomePage || isConfigurationsPage || isWorkflowsPage;

  const { botName, draftVersion, customerId, botId, projectId } =
    useProStudioCtxSelector((ctx) => ({
      botName: ctx.botName,
      draftVersion: ctx.draftVersion,
      customerId: ctx.customerId,
      projectId: ctx.project?.projectProStudioSetting?.id,
      botId:
        ctx.customerId && ctx.botName
          ? `${ctx.customerId}.${ctx.botName}`
          : undefined,
    }));

  const solutionVersionId = useMemo(() => {
    if (!draftVersion || !botName || !customerId) {
      return '';
    }

    return `${customerId}-${botName}-${draftVersion}`;
  }, [customerId, botName, draftVersion]);

  useEffect(() => {
    if (isWorkflowsPage) {
      return;
    }

    if (isFirstLevelPage) {
      tableStore.botId = '';
      tableStore.solutionVersionId = '';
      tableStore.projectProStudioSettingId = '';

      return;
    }

    if (!draftVersion || draftVersion === undefined) {
      if (tableStore.rows.length > 0) {
        tableStore.clearTable();
      }
      return;
    }

    if (botId) {
      tableStore.botId = botId;
    }

    if (projectId) {
      tableStore.projectProStudioSettingId = projectId;
    }

    if (
      solutionVersionId &&
      solutionVersionId !== tableStore.solutionVersionId
    ) {
      tableStore.solutionVersionId = solutionVersionId;
    }

    if (draftVersion !== tableStore.draftVersion) {
      tableStore.draftVersion = draftVersion;
    }
  }, [
    solutionVersionId,
    draftVersion,
    botId,
    projectId,
    isFirstLevelPage,
    isWorkflowsPage,
  ]);
};
